// The concrete screens a journey config may name.
//
// Keys are what `screen:` / `landing:` in src/config/journeys/* refer to.
// Adding a bespoke screen is one entry here; its routes come from the config.
//
// LOADED LAZILY, and that is the point.
//
// These imports used to be static, so the one bundle every visitor downloads
// carried all four landing pages, both quote screens, the compare screens, the
// summaries and the 39 KB document-upload page — whether the visitor went near
// them or not. A customer opening the home page paid for the motor funnel, and
// an agent quoting travel paid for pet and life.
//
// React.lazy returns a component, so the registry contract is unchanged:
// `getScreen(key)` still answers with something renderable, and `elementFor`
// still mounts it. What changes is that webpack emits one chunk per screen and
// the browser fetches it when the route is first visited. The <Suspense>
// boundary that makes this legal lives in App.js, above <Routes>.
import { lazy } from "react";
import { registerScreens } from "./components/journey/screens";

registerScreens({
  "document-upload": lazy(() => import("./components/pages/TravelInsurance/DocumentUpload")),
  "quote-details": lazy(() => import("./components/pages/QuoteDetailsScreen")),
  "quote-compare": lazy(() => import("./components/pages/QuoteCompareScreen")),
  "plan-summary": lazy(() => import("./components/pages/PlanSummaryScreen")),
  "motor-plans": lazy(() => import("./components/pages/MotorInsurance/MotorPlans")),
  "motor-compare": lazy(() => import("./components/pages/MotorInsurance/MotorCompare")),
  "motor-summary": lazy(() => import("./components/pages/MotorInsurance/MotorSummary")),
  "landing:travel": lazy(() => import("./components/pages/TravelInsurance/TravelLandingPage")),
  "landing:pet": lazy(() => import("./components/pages/PetInsurance/PetLandingPage")),
  "landing:motor": lazy(() => import("./components/pages/MotorInsurance/MotorLandingPage")),
  "landing:life": lazy(() => import("./components/pages/LifeInsurance/LifeLandingPage")),
});
